import React from 'react'
import UserService from '../../store/services/UserService'
import { Navigate } from 'react-router-dom'
import navigation from '../../config/navigation'

const LandingPageView = () => {
  const isLoggedIn = UserService.isLoggedIn()

  if (!isLoggedIn) return <Navigate to={navigation.login} />

  return <Navigate to={'/loading'} />
}

export default LandingPageView
